import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=6ba5c534&scoped=true&"
import script from "./CouponList.vue?vue&type=script&lang=js&"
export * from "./CouponList.vue?vue&type=script&lang=js&"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=6ba5c534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5c534",
  null
  
)

export default component.exports